<!-- <div class="payment-success-card" *ngIf="showSuccess">
  <div class="success-icon">✔</div>
  <h2>Payment successful</h2>

  <div class="details">
    <div><strong>Payment type:</strong> {{ payment.paymentType }}</div>
    <div><strong>Bank:</strong> {{ payment.bank }}</div>
    <div><strong>Mobile:</strong> {{  moblieNumber }}</div>
    <div><strong>Plan name:</strong> {{ planName }}</div>
    <div><strong>Amount paid:</strong> ₹{{ planPrice }}</div>
    <div><strong>Transaction id:</strong> {{ payment.transactionId }}</div>
  </div>

  <div class="button-group">
    <button (click)="printReceipt()">Done</button>
  </div>
</div> -->

<div class="payment-success-card" *ngIf="showSuccess">
  <div class="success-icon"><i class="fa fa-check"></i></div>
  <h2>Recharge of ₹{{ payment.amount }} is successful!</h2>

  <div class="details">
    <div><strong>Payment type</strong> {{ payment.paymentType }}</div>
    <div><strong>Bank</strong> {{ payment.bank }}</div>
    <div><strong>Mobile</strong> {{ payment.mobile }}</div>
    <div><strong>Plan name</strong> {{ payment.plan }}</div>
    <div><strong>Amount paid</strong> ₹{{ payment.amount }}</div>
    <div><strong>Transaction id</strong> {{ payment.transactionId }}</div>
  </div>

  <p class="small text-white-75 text-center">
    <b>Recharge request submitted</b>, benefits will reflect shortly.
    If you have an active plan, the new plan will be queued.
    You can view & activate the new plan from <b>'Upcoming plan'</b> in My plan
    page.
  </p>

  <div class="button-group">
    <!-- <button (click)="printReceipt()">PRINT</button> -->
    <button (click)="printReceipt()">Done</button>
  </div>
</div>

<div class="payment-success-card">
  <div class="failed-icon"><i class="pe-7s-close-circle"></i></div>
  <h2>Recharge of ₹{{ payment.amount }} is Failed!</h2>

  <div class="button-group">
    <!-- <button (click)="printReceipt()">PRINT</button> -->
    <button (click)="printReceipt()">Try Again</button>
  </div>
</div>
